import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import styled from 'styled-components';
import { PageTitle } from '../CoachDashboard/styles';
import BananaCup from '../BananaCup/BananaCup';
import { athleteAPI } from '../../services/api';

const Container = styled.div`
  width: 100%;
`;

const JumperBananaCup: React.FC = () => {
  const { user } = useAuth();
  const [athleteId, setAthleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadAthleteId = async () => {
      if (user?.role === 'athlete') {
        try {
          const athlete = await athleteAPI.getMyAthlete();
          setAthleteId(athlete._id);
        } catch (error) {
          console.error('Error loading athlete:', error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    if (user?.athleteId) {
      setAthleteId(user.athleteId);
      setIsLoading(false);
    } else {
      loadAthleteId();
    }
  }, [user]);

  if (isLoading) {
    return (
      <Container>
        <PageTitle>Banana Cup</PageTitle>
        <p style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-gray)' }}>
          Loading...
        </p>
      </Container>
    );
  }

  return (
    <Container>
      <BananaCup athleteId={athleteId || undefined} />
    </Container>
  );
};

export default JumperBananaCup;

